<template>
  <div id="app">
    <v-app footer>
      <v-content>
        <router-view/>
      </v-content>
    </v-app>
  </div>
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      
    }
  }
}
</script>

<style>
@font-face {
  font-family: "Roboto";
  src: local("Roboto"), url("./assets/Roboto-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: local("Roboto-Bold"), url("./assets/Roboto-Bold.ttf") format("truetype");
  font-weight: bold;
  font-style: normal;
}

#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #56544d;
  background-color: white;
}

a:visited {
    
    text-decoration: none;
}
a:link {
    
    text-decoration: none;
}
a {
    
    text-decoration: none;
}

p {
  margin: 0;
}
</style>
